import React, { FC } from "react";
import SchemaOutlinedIcon from "@mui/icons-material/SchemaOutlined";

export const SchemaIcon: FC<any> = (props) => {
  return <SchemaOutlinedIcon style={{ fontSize: 18 }} {...props} />;
};
